module.exports = __webpack_public_path__ + "static/media/sausage.e2125c0a.svg";